
























































import { Component, Vue } from "vue-property-decorator";
import FiltersRow from "@/components/FiltersRow.vue";
import ResourceCell from "@/components/ResourceCell.vue";
import ProjectCell from "@/components/ProjectCell.vue";
import DescriptionCell from "@/components/DescriptionCell.vue";
import TypeCell from "@/components/TypeCell.vue";
import SavingsCostCell from "@/components/SavingsCostCell.vue";
import ApplyAndStatusCell from "@/components/ApplyAndStatusCell.vue";
import { IRootStoreState } from "../store/root";
import { RecommendationExtra } from "../store/model";

@Component({
  components: {
    FiltersRow,
    ResourceCell,
    ProjectCell,
    TypeCell,
    DescriptionCell,
    SavingsCostCell,
    ApplyAndStatusCell
  }
})
export default class CoreTable extends Vue {
  // headers ending with "Col" have values that are bound to corresponding properties
  //  for example, Resource will take RecommendationExtra.resourceCol for sorting
  headers = [
    {
      text: "Resource",
      value: "resourceCol",
      sortable: true
    },
    { text: "Project", value: "projectCol", sortable: true },
    {
      text: "Type",
      value: "typeCol",
      sortable: true
    },
    {
      text: "Description",
      value: "description",
      sortable: false
    },
    {
      text: "Savings/cost per week",
      value: "costCol",
      sortable: true
    },
    { text: "", value: "statusCol", sortable: false }
  ];

  get selectedRows(): RecommendationExtra[] {
    return (this.$store.state as IRootStoreState).coreTableStore!.selected;
  }

  set selectedRows(selected: RecommendationExtra[]) {
    this.$store.commit("coreTableStore/setSelected", selected);
  }
}
